import { render, staticRenderFns } from "./combined-picture.vue?vue&type=template&id=7becc8a6&scoped=true&"
import script from "./combined-picture.vue?vue&type=script&lang=ts&"
export * from "./combined-picture.vue?vue&type=script&lang=ts&"
import style0 from "./combined-picture.vue?vue&type=style&index=0&id=7becc8a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7becc8a6",
  null
  
)

export default component.exports